import React, {
    useState,
    useEffect,
    useRef,
    useContext
} from 'react';
import {
    ModalNext,
    ModalBody,
} from '@jutro/components';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useTranslator } from '@jutro/locale';
import classNames from 'classnames';
import appConfig from 'app-config';
import { MLProgressModalContext } from 'ml-portals-util-react';
import spinnerImg from 'ml-digital-theme-styles/images/cakeandarrow/img/icons/metlife-spinner.gif';
import metadata from './MLProgressModal.metadata.json5';
import styles from './MLProgressModal.module.scss';


function MLProgressModal() {
    const { progressModalState } = useContext(MLProgressModalContext);
    const translator = useTranslator();
    const {
        active,
        title,
        initDelay
    } = progressModalState;

    const [percentage, setPercentage] = useState(0);
    // const [active, setActive] = useState(false);
    const percentageRef = useRef(percentage);
    const originalModalClassnames = [styles['modal-dialog'], styles['ml-modal-loading']];
    const [modalMainClassnames, setModalMainClassnames] = useState([...originalModalClassnames]);
    const originalOverlayClassnames = [styles['noHorizontalPadding'], styles['overlay-init-opacity']];
    const [modalOverlayClassNames, setModalOverlayClassNames] = useState([...originalOverlayClassnames]);


    const isQB = appConfig.portalCode === 'QB';
    const isAMP = appConfig.portalCode === 'AMP';

    const getDelay = () => {
        const delay = initDelay;
        /* switch ($state.current.name) {
            case 'generateQuote':
            case 'paCalculatePremiumDisclosure':
                delay = 0;
                break;
            default:
                break;
        } */

        return delay;
    };

    const getProgressIncrement = () => {
        const items = [0, 0, 1, 2, 3, 4];
        return items[Math.floor((Math.random() * items.length))];
    };

    useEffect(() => {
        percentageRef.current = percentage;
    });

    useEffect(() => {
        if(active) {
            const modalInitTimer = setTimeout(() => {
                setModalMainClassnames([...originalModalClassnames, styles.in])
                setModalOverlayClassNames([...originalOverlayClassnames, styles.overlayIn])
            }, getDelay());

            let progressInterval;
            const progressTimer = setTimeout(() => {
                const progressMax = 92;
                setPercentage(0);
                progressInterval = setInterval(() => {
                    if (percentageRef.current < progressMax) {
                        setPercentage(percentageRef.current + getProgressIncrement());
                    } else {
                        clearInterval(progressInterval);
                    }
                }, 500);    
            }, getDelay() + 7500);

            return () => {
                clearTimeout(modalInitTimer);
                clearInterval(progressInterval);
                clearTimeout(progressTimer);
            }
        }
        if(modalMainClassnames.length > 2) {
            setModalMainClassnames([...originalModalClassnames]);
        }

        setModalOverlayClassNames([...originalOverlayClassnames]);

        if(percentage > 0) {
            setPercentage(0);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [active]);

    const overrides = {
        spinnerContainer: {
            visible: !(isQB || isAMP)
        },
        spinner: {
            src: spinnerImg
        },
        farmerLoadingAnimationContainer: {
            visible: (isQB || isAMP)
        },
        primaryMessageContainer: {
            visible: !!title
        },
        primaryMessage: {
            content: typeof title === "object" ? translator(title) : title
        },
        barContainer3: {
            "aria-valuenow": percentage,
            style: {width: `${percentage}%`}
        },
        percentage: {
            content: `${percentage}% Complete`,
        }
    }

    // Jasper Fix - Don't return React.Fragment when Modal is closed, instead set isOpen flag in ModalNext
    /*if(!active) {
        return <React.Fragment />;
    }*/

    return (
        <ModalNext
            className={classNames([...modalMainClassnames])}
            overlayClassName={ classNames([...modalOverlayClassNames]) }
            isOpen={active}
            shouldCloseOnOverlayClick={false}
            shouldCloseOnEsc={false}
        >
            <ModalBody contentLayout={{
                component: 'div',
                componentProps: {
                    className:  styles['modal-content']
                }
            }}
            >
                <ViewModelForm
                    uiProps={metadata.componentContent}
                    overrideProps={overrides}
                    classNameMap={styles}
                />
            </ModalBody>
        </ModalNext>
    );
};

MLProgressModal.propTypes = {
};

MLProgressModal.defaultProps = {
};

export default MLProgressModal;
